import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const INTEGRATIONS_USERMAP_CONNECTION_TYPES_QUERY_KEY = 'integrations-usermap-connection-types';

export function useGetExternalIntegrationUserMapConnectionTypesQuery({
	enabled = true,
	impersonationContext,
	integrationProvider,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
	integrationProvider: Api.IntegrationProvider;
}) {
	const userSession = useUserSession();
	return useQuery<string[]>({
		enabled,
		queryFn: () =>
			userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/userMaps/connectionTypes`,
				}),
				'GET'
			),
		queryKey: [INTEGRATIONS_USERMAP_CONNECTION_TYPES_QUERY_KEY, integrationProvider, impersonationContext],
		// Connection types only change when the ETL transform runs — safe to cache long.
		staleTime: 5 * 60 * 1000,
		meta: {
			toastErrorMessage: 'Failed to load connection types',
			errorLogging: {
				category: 'UserMappingsView',
				action: 'LoadConnectionTypes-Error',
			},
		},
	});
}

export const invalidateUserMapConnectionTypesQuery = ({
	impersonationContext,
	integrationProvider,
}: {
	impersonationContext?: Api.IImpersonationContext;
	integrationProvider: Api.IntegrationProvider;
}) =>
	reactQueryClient.invalidateQueries({
		queryKey: [INTEGRATIONS_USERMAP_CONNECTION_TYPES_QUERY_KEY, integrationProvider, impersonationContext],
	});
